"use strict";var e=require("./useAsyncFn.js"),s=require("react");exports.useAsync=(r,n=[])=>{const[u,c]=e.useAsyncFn(r,n,{isLoading:!0});return s.useEffect((()=>{c()}),[c]),u};
//# sourceMappingURL=useAsync.js.map
